// ** React Imports
import { type ReactNode } from 'react'

// ** Icon Imports
import { CheckContained } from '@/shared/ui/icons'

// ** Styled Components
import {
	CardWrapper,
	CheckRow,
	HeadingRow,
	PricingRow,
	StyledHeading,
	StyledSpan,
	StyledTypography
} from './styles'

// ** Type Imports
import { OptionType } from '../model/types'

// ** Component Imports
import { EnterpriseModal } from './EnterpriseModal/EnterpriseModal'

interface IProps {
	type?: OptionType
	className?: string
	title: string
	additionalTitleElement?: ReactNode
	description: string
	price: string | number
	features: Array<{ id: number; label: string }>
	buttonSettings: {
		label: string
		variant: 'primary' | 'secondary'
	}
}

/**
 * Static comparison card (the enterprise "contact sales" offer). The user's own
 * priced plan is rendered from the API by `PlanCard` instead.
 */
export const SubscriptionCard = ({
	type,
	className,
	title,
	additionalTitleElement,
	description,
	price,
	features,
	buttonSettings
}: IProps) => {
	return (
		<CardWrapper className={className}>
			<HeadingRow>
				<StyledHeading variant='h4' weight='semi-bold'>
					{title.toUpperCase()}
				</StyledHeading>

				{additionalTitleElement && additionalTitleElement}
			</HeadingRow>

			<StyledTypography>{description}</StyledTypography>

			<PricingRow>
				<StyledSpan>
					<StyledHeading variant='h2' weight='bold'>
						{price}
					</StyledHeading>
				</StyledSpan>
			</PricingRow>

			{features.map((feature) => (
				<CheckRow key={feature.id}>
					<CheckContained />

					<StyledTypography weight='regular'>{feature.label}</StyledTypography>
				</CheckRow>
			))}

			{type === OptionType.ENTERPRISE && (
				<EnterpriseModal
					label={buttonSettings.label}
					variant={buttonSettings.variant}
				/>
			)}
		</CardWrapper>
	)
}
